import React from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';
import CheckoutDeliveryMethods from "../Components/Checkout.DeliveryMethods";
import DatePickerContainer from "../Containers/DatePicker.Container";

const CheckoutBusinessCustomerInfo = (props) => {
    const { companyBillingAddresses = [], companyShippingAddresses = [], companyName, authenticated, selectedBillingCompanyAddressId, selectedShippingCompanyAddressId, onChange, setSelectedBillingCompanyAddress, setSelectedShippingCompanyAddress, errors = {},
                    onDeliveryChange,
                    deliveryMethods,
                    selectedId,
                    customerDetails,
                    onDetailsChange } = props;

    const input = (cssClass, stateKey, id, autoComplete = null, placeholder = null, type = 'text', hideName = false, disableInput = false) => (
        <div className={cssClass}>
            {!hideName &&
                <label className="form__label" htmlFor={`${stateKey}-${id}`}>{translate(`checkout.customerinfo.${id.toLowerCase()}`)}&#8203;</label>
            }
            <div className='checkout__form-container'>
                <input className="form__input" disabled={!authenticated || disableInput ? true : false} id={`${stateKey}-${id}`} name={`${stateKey}-${id}`} type={type}
                    value={(props[stateKey] || {})[id] || ''} placeholder={placeholder} autoComplete={autoComplete}
                    onChange={(event) => onChange(stateKey, id, event.target.value)}/>
                    <span>{translate(`checkout.customerinfo.${id.toLowerCase()}`)}</span>
                </div>
            {errors[`${stateKey}-${id}`] &&
                <span className="form__validator--error form__validator--top-narrow" data-error-for={`${stateKey}-${id}`}>{errors[`${stateKey}-${id}`][0]}</span>
            }
        </div>
    );
    const selectedBillingAddress = selectedBillingCompanyAddressId && companyBillingAddresses ? companyBillingAddresses.find(address => address.systemId === selectedBillingCompanyAddressId) : null;
    const selectedShippingAddress = selectedShippingCompanyAddressId && companyShippingAddresses ? companyShippingAddresses.find(address => address.systemId === selectedShippingCompanyAddressId) : null;
    const getCountry = (address) => {
        const addressCountry = constants.countries ? constants.countries.find(country => country.value === address.country) : null;
        return addressCountry ? addressCountry.text : address.country;
    };
    return (
        <div className="row checkout-info__container checkout__customer-specification">
            <div className="small-12 checkout__delivery-container">
                <h4 className="small-12 checkout__delivery-title">{translate('checkout.deliveryinfo')}</h4>
                <div className="checkout__delivery-wrapper column">
                    <div className="checkout__customer-information-wrapper">
                        {input('checkout__att-field', 'customerDetails', 'att', 'att')}
                        {input('checkout__att-field', 'customerDetails', 'customerOrderNo', 'customerOrderNo')}
                    </div>
                    <div className="form__label">{translate('checkout.customerinfo.address')}</div>
                    <div className="small-12">
                        <select className="form__input" value={selectedShippingCompanyAddressId || ''} disabled={!authenticated}
                            onChange={(event) => setSelectedShippingCompanyAddress(event.target.value, companyShippingAddresses.find(address => address.systemId === event.target.value).country)}>
                            <option value='' disabled>{translate('checkout.customerinfo.companyaddress.placeholder')}</option>
                            {companyShippingAddresses && companyShippingAddresses.map((address) =>
                                <option value={address.systemId} key={`companyAddress-${address.systemId}`}>{`${address.address}, ${address.zipCode}, ${address.city}, ${getCountry(address)}`}</option>
                            )}
                        </select>
                        {errors['selectedShippingCompanyAddressId'] &&
                            <span className="form__validator--error form__validator--top-narrow" data-error-for='selectedShippingCompanyAddressId'>{errors['selectedShippingCompanyAddressId'][0]}</span>
                        }
                    </div>
                </div>
                { selectedShippingAddress &&
                    <div className='column'>
                        <label className="form__label checkout__order-adress-title">{translate('checkout.customerinfo.adressinfo')}</label>
                        <div className="checkout__order-adress-body">
                            <div>{companyName}</div>
                            <div>{selectedShippingAddress.address}</div>
                            <div>
                                <span>{selectedShippingAddress.zipCode}</span>&nbsp;
                                <span>{selectedShippingAddress.city}</span>
                            </div>
                            <div>{getCountry(selectedShippingAddress)}</div>
                        </div>
                    </div>
                }
                <div className='column'>
                    <CheckoutDeliveryMethods
                        deliveryMethods={deliveryMethods}
                        selectedId={selectedId}
                        onChange={onDeliveryChange}
                    />
                    {errors["selectedDeliveryMethod"] && (
                        <span className="form__validator--error form__validator--top-narrow">
                            {errors["selectedDeliveryMethod"][0]}
                        </span>
                    )}
                    <div className='form__label'>{translate('datepicker.choosedeliverydate')}</div>
                    <DatePickerContainer
                        customerDetails={customerDetails}
                        onDetailsChange={onDetailsChange}
                    />
                </div>
            </div>
            <div className="small-12 checkout__customer-container checkout__delivery-container">
                <h4 className="checkout__delivery-title">
                    {translate("checkout.delivery.title")}
                </h4>
                <div className='form__label column checkout__delivery-wrapper'>
                    <div className="small-12">{translate('checkout.customerinfo.reference')}</div>
                </div>
                <div className='checkout__delivery-container--row'>
                    {input('small-6 checkout__delivery-firstname column', 'customerDetails', 'firstName', 'billing given-name', null, 'text', true)}
                    {input('small-6 checkout__delivery-lastname column', 'customerDetails', 'lastName', 'billing family-name', null, 'text', true)}
                </div>
                <div className='checkout__delivery-container--row'>
                    {input('small-6 checkout__delivery-phone column', 'customerDetails', 'phoneNumber', 'billing tel', null, 'text', true)}
                    {input('small-6 checkout__delivery-phone column', 'customerDetails', 'email', 'confirmation email', null, 'text', true, true)}
                </div>
                <div className='checkout__delivery-container--row'>
                    <div className="checkout__order-adress-body small-6 column">
                        <div className='form__label'>{translate('checkout.invoiceaddress')}:</div>
                        <div>{companyName}</div>
                        {/* <div>{selectedBillingAddress.address}</div>
                        <div>
                            <span>{selectedBillingAddress.zipCode}</span>&nbsp;
                            <span>{selectedBillingAddress.city}</span>
                        </div>
                        <div>{getCountry(selectedBillingAddress)}</div> */}
                    </div>
                    <div className='small-6 column'>
                        <div className='form__label'>{translate('checkout.emaillabel')}:</div>
                        {props.customerDetails && props.customerDetails.companyEmail}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CheckoutBusinessCustomerInfo;